import { AlertTriangle } from "lucide-react";
import { getEnvironment, type Environment } from "@/lib/environment";

const LABELS: Record<Exclude<Environment, "production">, string> = {
  staging: "Staging",
  local: "Local Dev",
};

export function EnvironmentBanner() {
  const env = getEnvironment();
  if (env === "production") return null;

  const label = LABELS[env];
  const host = typeof window !== "undefined" ? window.location.hostname : "";

  return (
    <div
      role="status"
      aria-label={`Non-production environment: ${label}`}
      className="sticky top-0 z-[60] flex h-7 items-center justify-center gap-2 bg-amber-400 px-4 text-xs font-semibold uppercase tracking-wider text-amber-950 shadow-sm"
    >
      <AlertTriangle className="h-3.5 w-3.5" aria-hidden="true" />
      <span>
        {label} &mdash; {host}
      </span>
      <span className="hidden text-amber-900/80 sm:inline">&middot; Not production data</span>
    </div>
  );
}

export function EnvironmentPill() {
  const env = getEnvironment();
  if (env === "production") return null;

  const label = LABELS[env];

  return (
    <span className="inline-flex items-center rounded-full bg-amber-400 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-amber-950">
      {label}
    </span>
  );
}
